import { APP_USER_LOGS } from "../../actions/type";
export default function appUserLogs(state = {}, action) {
    switch (action.type) {
        case APP_USER_LOGS:
            return action.payload;
        default:
            return state
    }
}